import { render, staticRenderFns } from "./Genealogy.vue?vue&type=template&id=79afaaf9&scoped=true"
import script from "./Genealogy.vue?vue&type=script&lang=js"
export * from "./Genealogy.vue?vue&type=script&lang=js"
import style0 from "./Genealogy.vue?vue&type=style&index=0&id=79afaaf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79afaaf9",
  null
  
)

export default component.exports